import Table from "@tiptap/extension-table";
import { getHTMLFromFragment } from "@tiptap/core";
import { Fragment, Node as ProseMirrorNode } from "@tiptap/pm/model";
import { columnResizing, tableEditing } from "@tiptap/pm/tables";

interface MarkdownSerializerState {
  write(content: string): void;
  closeBlock(node: ProseMirrorNode): void;
}

export const CustomTable = Table.extend({
  addProseMirrorPlugins() {
    const isResizable = this.options.resizable;

    return [
      ...(isResizable
        ? [
            columnResizing({
              handleWidth: this.options.handleWidth,
              cellMinWidth: this.options.cellMinWidth,
              defaultCellMinWidth: this.options.cellMinWidth,
              View: this.options.View,
              lastColumnResizable: this.options.lastColumnResizable
            })
          ]
        : []),
      tableEditing({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },

  addStorage() {
    return {
      ...this.parent?.(),
      markdown: {
        serialize(state: MarkdownSerializerState, node: ProseMirrorNode) {
          const schema = node.type.schema;
          const html = getHTMLFromFragment(Fragment.from(node), schema);
          state.write(formatBlock(html));
          state.closeBlock(node);
        },
        parse: {
          // handled by markdown-it
        }
      }
    };
  }
});

function formatBlock(html: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const element = doc.body.firstElementChild as HTMLElement;

  if (element) {
    element.innerHTML = element.innerHTML.trim() ? `\n${element.innerHTML}\n` : `\n`;
    return element.outerHTML;
  }

  return html;
}
